import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { AppSettings } from 'src/app/shared/AppSettings';
import { tPatientService } from 'src/app/services/tPatient.service';
import { CrypService } from 'src/app/services/Non-Master/Cryp.service';

@Component({
  selector: 'app-patient-hospital-admission',
  templateUrl: './patient-hospital-admission.component.html',
  styleUrls: ['./patient-hospital-admission.component.css']
})
export class PatientHospitalAdmissionComponent implements OnInit {
  @Input() patientID: string;

  patient = {
    patientID:"",
    name:"",
    surname:"",
    dob:"",
    hkid:"",
    hkidDesc:"",
    registeredDate:"",
    caseDrID:"",
    gender:"",
    age:""
  };

  constructor(
    public activeModal: NgbActiveModal,
    private patientService : tPatientService,
    private crypService: CrypService,
    private datePipe : DatePipe
  ) { }

  ngOnInit() {
    this.initPatientInfo();
  }

  initPatientInfo(){
    this.patientService.getLabelPrint(this.patientID,1).subscribe(x=>{

      this.patient = x.data;
      this.patient.hkid = this.crypService.decryptStr(this.patient.hkid).toString();
    })
  }

  getMarginLeftWithName(length){
    return 60;
  }

  getDateFomrat(value){
    if(!value) return "";
    return this.datePipe.transform(value,AppSettings.dateFormat);
  }

}
